module.exports = __webpack_public_path__ + "static/media/PB_Y_08.dc652241.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/progress_bar/yellow/PB_Y_08.png
// module id = 237
// module chunks = 0